import type { FaireProductEntity } from "../../entity_types/product";

export const p_q42axw55py: FaireProductEntity = {
  token: "p_q42axw55py",
  type: "product",
  name: "Bookworm - Vintage Rainbow repeat Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/9eac87c0b0b965af33c066458ee5a7160b14dda36b69952cbed69e83d4ac2f00.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/025a260e6a78899f6c45dbd086e0dc5f0dd2d7dd2d6397e0bf3e9fd9fd6763ef.jpeg",
    "https://cdn.faire.com/fastly/a43ea261da1bad6f2e5898bf7afffbaf182ad8ee49f6a8dffad4abdd1e53809f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/463f8232c89fa825081c4d8c795cbc3ec2976a8f0684ec509a4773b71fa9a5f2.jpeg",
    "https://cdn.faire.com/fastly/b2afc99d3119db290634071f7ca8219b63d1dbf0efab1068cdd71cd304986c6e.jpeg",
    "https://cdn.faire.com/fastly/e8eab31b17c2d260df88d8f44bac7a7c0eb44872ba9baa72b1c18d26b62c715d.jpeg",
    "https://cdn.faire.com/fastly/6de4772107988968efe6d8fd78af2d6ec32b7eec4f22cf1b78b0749a381d9fb8.jpeg"
  ],
  priceDollars: 6.75,
  description: "These gym socks will keep you comfy and cozy through whatever adventure you go on (fiction or non-fiction). Dig your toesies into these socks and your nose into a good book 📚 🧦 .\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:27.589Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
